import { render } from "./test-banner.vue?vue&type=template&id=6717b5e2&scoped=true"
import script from "./test-banner.vue?vue&type=script&lang=js"
export * from "./test-banner.vue?vue&type=script&lang=js"

import "./test-banner.vue?vue&type=style&index=0&id=6717b5e2&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6717b5e2"]])

export default __exports__